import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Center, Space, Stack, Text, Title } from '@mantine/core';
import SampleSearchBar from 'apps/Lab/Samples/common/SampleSearchBar';

import { RootState } from 'store';
import { Header } from 'common';
import ErrorAlert from 'common/ErrorAlert';

import { handleBulkDensitySearchResult } from '../utils/sampleSearchUtils';

import styles from 'apps/Lab/Samples/Overview/Container.module.css';

const LabCarbonContainer = () => {
  const { t } = useTranslation();

  const { isFetching, errorMessage } = useSelector((state: RootState) => ({
    isFetching: state.labSamples.isFetching,
    errorMessage: state.labSamples.errorMessage,
  }));

  return (
    <>
      <Header title={t('carbon')} />
      <Center>
        <Stack align="center" gap="lg">
          <Space h="lg" />
          <Title order={3}>{`${t('bulkDensityInputSearch')}:`}</Title>
          <SampleSearchBar
            className={styles.Input}
            autofocus
            handleSearchResult={handleBulkDensitySearchResult}
          />
          {isFetching && <Text>{`${t('searching')}...`}</Text>}
          {errorMessage && <ErrorAlert content={errorMessage} />}
        </Stack>
      </Center>
    </>
  );
};

export default LabCarbonContainer;
